import styled from 'styled-components';

export const Container = styled.footer`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: auto;
`;
